import sortBy from "lodash/sortBy";
import values from "lodash/values";
import { FiltersV2 } from "PFTypes/filters_v2";

export const getSortedFiltersArray = (filters: FiltersV2) => sortBy(values(filters), ["ordinal", "name"]);
